import { Routes } from '@angular/router';

// Valid paths for deep linking - only main views that can be directly navigated to
export const VALID_DEEP_LINK_PATHS = [
  '/gallery', '/table', '/phone-list', '/timeline', '/calendar', '/orgchart'
];

// Valid prefixes for parameterized deep link routes
export const VALID_DEEP_LINK_PREFIXES = ['/user/'];

export const routes: Routes = [
  {
    path: 'welcome',
    loadComponent: () => import('./pages/welcome/welcome.page').then( m => m.WelcomePage)
  },
  {
    path: 'loading',
    loadComponent: () => import('./pages/loading/loading.page').then( m => m.LoadingPage)
  },
  {
    path: 'gallery',
    loadComponent: () => import('./pages/gallery/gallery.page').then( m => m.GalleryPage)
  },
  {
    path: 'cards',
    redirectTo: 'gallery',
    pathMatch: 'full'
  },
  {
    path: 'table',
    loadComponent: () => import('./pages/table/table.page').then( m => m.TablePage)
  },
  {
    path: 'phone-list',
    loadComponent: () => import('./pages/phone-list/phone-list.page').then( m => m.PhoneListPage)
  },
  {
    path: 'timeline',
    loadComponent: () => import('./pages/timeline/timeline.page').then( m => m.TimelinePage)
  },
  {
    path: 'calendar',
    loadComponent: () => import('./pages/calendar/calendar.page').then( m => m.CalendarPage)
  },
  {
    path: 'orgchart',
    loadComponent: () => import('./pages/orgchart/orgchart.page').then( m => m.OrgchartPage)
  },
  {
    path: 'photo-flip',
    loadComponent: () => import('./pages/photo-flip/photo-flip.page').then( m => m.PhotoFlipPage)
  },
  {
    path: 'user/:id',
    loadComponent: () => import('./pages/member-view/member-view.page').then( m => m.MemberViewPage)
  },
  {
    path: 'search-filter',
    loadComponent: () => import('./pages/search-filter/search-filter.page').then( m => m.SearchFilterPage)
  },
  {
    path: 'preferences',
    loadComponent: () => import('./pages/preferences/preferences.page').then( m => m.PreferencesPage)
  },
  {
    path: 'admin-settings',
    loadComponent: () => import('./pages/admin-settings/admin-settings.page').then( m => m.AdminSettingsPage)
  },
  {
    path: 'owner-settings',
    loadComponent: () => import('./pages/owner-settings/owner-settings.page').then( m => m.OwnerSettingsPage)
  },
  {
    path: 'table-settings',
    loadComponent: () => import('./pages/table-settings/table-settings.page').then( m => m.TableSettingsPage)
  },
  {
    path: 'orgchart-settings',
    loadComponent: () => import('./pages/orgchart-settings/orgchart-settings.page').then( m => m.OrgchartSettingsPage)
  },
  {
    path: 'setup',
    loadComponent: () => import('./pages/setup/setup.page').then( m => m.SetupPage)
  },
  {
    path: 'status',
    loadComponent: () => import('./pages/status/status.page').then( m => m.StatusPage)
  },
  {
    path: '',
    loadComponent: () => import('../components/root-redirect/root-redirect.component').then(m => m.RootRedirectComponent),
    pathMatch: 'full',
  },
  {
    // Catch-all route for invalid URLs - redirect to home if logged in, welcome if not
    path: '**',
    loadComponent: () => import('../components/root-redirect/root-redirect.component').then(m => m.RootRedirectComponent),
  },
];
